
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import * as types from '../../types'

import { CardMedia, CardContent, CardActionArea, CardActions } from "@material-ui/core";
import PodCastTypeDialog from "../podcast/PodCastTypeDialog"
import { SelectedCategory } from "./DiscoveryView"
import discovery from '../../data/discovery'
import Tooltip from "@material-ui/core/Tooltip";
import Icon from "@material-ui/core/Icon";
import DiscoverIcon from "../../custom_components/DiscoverIcon"
import { cardTitle, boxShadow } from "src/assets/jss/material-dashboard-pro-react.jsx";

import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import ThumbsUp from "@material-ui/icons/ThumbUp";
import Edit from "@material-ui/icons/Edit";
import Place from "@material-ui/icons/Place";
import ArtTrack from "@material-ui/icons/ArtTrack";
import Language from "@material-ui/icons/Language";

// core components
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import Table from "src/components/Table/Table.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Danger from "src/components/Typography/Danger.jsx";
import Card from "src/components/Card/Card.jsx";
import CardHeader from "src/components/Card/CardHeader.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";
import CardFooter from "src/components/Card/CardFooter.jsx";

import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
  } from "src/variables/charts.jsx";
  
  import {
    successColor,
    tooltip,
   
  } from "src/assets/jss/material-dashboard-pro-react.jsx";
  
  const styles: any = theme => ( {

    right: {
        textAlign: "right"
    },
    center: {
        textAlign: "center"
    },
 
    icon: {
        verticalAlign: "middle",
        width: "17px",
        height: "17px",
        top: "-1px",
        position: "relative"
    },
    positionAbsolute: {
        position: "absolute",
        right: "0",
        top: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    categoryButtonDiv:{
         padding:'20px',
    whiteSpace:'nowrap',
    overflowX:'auto',
  
    
    }
});
interface DiscoveryItemsProps {
    classes: any;
    connect: types.IState,
    selectedCategory: SelectedCategory
}
interface DiscoveryItemsState {
    podcastTypeDialog: boolean;
    rssUrl: string;
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
class DiscoveryItems extends React.Component<DiscoveryItemsProps, DiscoveryItemsState> {


    constructor(props: DiscoveryItemsProps) {
        super(props);

        this.state = {
            podcastTypeDialog:false,
            rssUrl:undefined

        };
        this.cache = {}

    }
    cache: {}
    render() {
        let articles = [];
        if (!this.cache[this.props.selectedCategory]) {
            this.cache[this.props.selectedCategory] = discovery.filter(x => x.category == this.props.selectedCategory.toString())
        }
        articles = this.cache[this.props.selectedCategory]
        const { classes } = this.props;
        let me = this;
        return (
            <GridContainer>
                {articles.map(article => (
                    <GridItem xs={12} sm={12} md={6}>
                        <Card product className={classes.cardHover}>
                        <CardHeader color="primary" icon>
                        <CardIcon color="primary" style={{
                            background:"lightgray",
                            boxShadow:"0 12px 20px -10px rgba(39, 39, 39, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(39, 39, 39, 0.2)"
                        }}>
                                        <img src={article.rss_image_url} width='40px' height='40px' />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>{article.title} </h4>
                                

                         
              </CardHeader>
                            <CardBody>
                                <div className={classes.cardHoverUnder}>
                                  
                                </div>
                               
                                <p className={classes.cardProductDesciprion}>
                                  {article.description}
              </p>
                            </CardBody>
                            <CardFooter product>
                                <div className={classes.price}>
                                    <h4>{numberWithCommas(article.votes)} <ThumbsUp/> </h4>
                                </div>
                                <div className={`${classes.stats} ${classes.productStats}`}>
                                <Button
                                        color="rose"
                                        onClick={(e)=>{
                                            let s = {...me.state};
                                            s.rssUrl = article.rss_url;
                                            s.podcastTypeDialog = true;
                                            me.setState(s)
                                        }}
                                        variant="contained"
                                       

                                        className={classes.registerButton}
                                    >



                                        <span>Make Podcast</span>

                                    </Button>
              </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                ))}
                  <PodCastTypeDialog
                    open={this.state.podcastTypeDialog}
                    podcastUrl = {this.state.rssUrl}
                    close={() => {
                        let s = { ...me.state };
                        s.podcastTypeDialog = false;
                        me.setState(s)
                    }} />
            </GridContainer>

        )

    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(DiscoveryItems));







// WEBPACK FOOTER //
// ./src/views/discovery/DiscoveryItems.tsx